import { Box, Typography } from '@mui/material'
import LoadingMessage from '@/components/feedbacks/LoadingMessage'
import {
  useGetBulkFieldsQuery,
  useGetUserCanBulkEditQuery,
} from '@/features/bulk-edit/api'
import BulkEditForm from '@/features/bulk-edit/components/BulkEditForm'
import type { Id } from '@/features/bulk-edit/types'
import type { MediaType } from '@/features/media/types'
import useUrlParams from '@/hooks/useUrlParams'
import BulkEditNoMedia from './BulkEditNoMedia'
import BulkEditPrevalidateError from './BulkEditPrevalidateError'

export function BulkEditPage() {
  //Get ids from url params
  let { mediaNumbers, mediaType } = useUrlParams()
  if (!Array.isArray(mediaNumbers)) mediaNumbers = [mediaNumbers]
  if (Array.isArray(mediaType)) mediaType = mediaType[0]

  const hasQueryInfo = mediaType && mediaNumbers

  const bulkEditCheck = useGetUserCanBulkEditQuery(
    { mediaNumbers, mediaType } as { mediaNumbers: Id[]; mediaType: MediaType },
    { skip: !mediaNumbers || !mediaNumbers.length },
  )
  const bulkFields = useGetBulkFieldsQuery(mediaType as MediaType, {
    skip: !hasQueryInfo,
  })

  if (!mediaNumbers || mediaNumbers?.length === 0) {
    return <BulkEditNoMedia />
  }

  if (
    bulkEditCheck?.data === false ||
    bulkEditCheck.isError ||
    bulkFields.isError
  ) {
    return <BulkEditPrevalidateError />
  }

  if (bulkFields.isLoading || bulkEditCheck.isLoading) {
    return (
      <Box p={2}>
        <LoadingMessage />
      </Box>
    )
  }

  return (
    <>
      <Typography variant="h2">Bulk Edit:</Typography>
      <Typography>{`Changes will affect ${mediaNumbers.length} documents.`}</Typography>
      <BulkEditForm />
    </>
  )
}
